"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualReviewRequiredReasonTypeCode = void 0;
var ManualReviewRequiredReasonTypeCode;
(function (ManualReviewRequiredReasonTypeCode) {
    ManualReviewRequiredReasonTypeCode["CondoExpenses"] = "01";
    ManualReviewRequiredReasonTypeCode["DeferredOrSkippedPayments"] = "02";
    ManualReviewRequiredReasonTypeCode["MortgageTranscript"] = "03";
    ManualReviewRequiredReasonTypeCode["PropertyDamage"] = "04";
    ManualReviewRequiredReasonTypeCode["PropertyRepairs"] = "05";
    ManualReviewRequiredReasonTypeCode["ReviewRequestedByLender"] = "06";
    ManualReviewRequiredReasonTypeCode["Other"] = "07";
})(ManualReviewRequiredReasonTypeCode = exports.ManualReviewRequiredReasonTypeCode || (exports.ManualReviewRequiredReasonTypeCode = {}));
